<template lang="pug" @touchmove.prevent>
  .renewal-container(v-if="show")
    .renewal-block
      .renewal-close(@click="close")
        img(src="https://m.hellobike.com/resource/gallery/61/QbulBDc17p.png?x-oss-process=image/quality,q_80")
      .renewal-block-title 自动续费管理
      .renewal-top
        .auto-left
          .auto-img
            img.icon(src="https://m.hellobike.com/resource/helloyun/08345/LCox04uOFq.png")
          .auto-word
            .auto-top-word 你好，超级会员
            .auto-bottom-word 已开通自动续费
        .auto-right(@click="closeRenew") 关闭自动续费
      .renewal-table
        .auto-item(v-if='isUnionMember')
          .auto-item-left 自动续费套餐
          .auto-item-right-flex
            .auto-item-top 联名会员
            .auto-item-bottom {{ unionDesc }}
        .auto-item(v-if='isUnionMember' v-for="(item,index) in tableList.slice(1)"
          :class="{'last-item': index === tableList.length - 1}")
          .auto-item-left {{item.label}}
          .auto-item-right {{item.value}}
        .auto-item(v-if='!isUnionMember' v-for="(item,index) in tableList"
          :class="{'last-item': index === tableList.length - 1}")
          .auto-item-left {{item.label}}
          .auto-item-right {{item.value}}
    .shadow(@click="close")
    AutoRenewBlock(:show.sync="showDialog" :cancelSignDelay="cancelSignDelay" @refresh="refresh")
    AutoRenewBlock2(:show.sync="showDialogNew" :cancelSignDelay="cancelSignDelay"
    :price="price"
    :nextRenewalAmount="nextRenewalAmount"
    :amountSaved="amountSaved"
    @close="closeModal"
    @refresh="refresh")

  </template>
<script>
import dayjs from 'dayjs';
import {
  getTokenAndLocation,
} from '@/utils';
import { env } from '@hb/hbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { userVipSignInfoSearch } from '@/api/vip';
import AutoRenewBlock from './auto-renew-block.vue';
import AutoRenewBlock2 from './auto-renew-block2.vue';

export default {
  components: {
    AutoRenewBlock,
    AutoRenewBlock2,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    unionVip: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      env,
      showDialog: false,
      showDialogNew: false,
      tableList: [
        { label: '自动续费套餐', value: '' },
        { label: '签约渠道', value: '' },
        { label: '下次续费日期', value: '' },
        { label: '下次续费金额', value: '' }],
      signChannelMap: {
        alipay: '支付宝',
        wechatTrust: '微信',
        douyinTrust: '抖音',
      },
      signChannel: '',
      propVersion: '',
      nextRenewalDate: '',
      nextRenewalAmount: 0,
      propVersionMap: {
        normal: '超级会员',
        ladder: '畅享出行',
        ride: '随心骑',
        ride_app: '随心骑',
        ladder_app: '畅享出行',
        ride_trial: '随心骑',
        ride_ebike: '轻松骑',
        ride_ebike_app: '轻松骑',
        ladder_blend: '畅享出行',
        ride_ebike_fifteen: '轻松骑',
        ride_ebike_thirty: '轻松骑',
        ladder_blend_two: '畅享出行',
        ride_universal: '随心骑',
        ride_steady_version: '随心骑',
        ride_radical_version: '随心骑',
        ladder_discount_95_rate: '畅享出行',
        ride_one_cent: '随心骑',
      },
      cancelSignDelay: 500,
      isNew: null,
      isRetentionWindowAB: false,
      price: 0,
      amountSaved: 0,
    };
  },
  computed: {
    isUnionMember() {
      return !!this.unionVip.userVipPropGuid;
    },
    unionDesc() {
      if (this.unionVip.additionalName) {
        return `${this.propVersion ? this.propVersionMap[this.propVersion] : ''}+${this.unionVip.additionalName}`;
      }
      return this.propVersionMap[this.propVersion];
    },
  },
  destroyed() {
  },
  created() {
    this.getData();
  },
  methods: {
    refresh() {
      this.$emit('refresh');
      this.close();
    },
    closeModal() {
      this.close();
    },
    close() {
      this.$emit('update:show', false);
    },
    async getData() {
      const { goodsGuid } = this.$route.query;
      const { token, cityCode } = await getTokenAndLocation();
      try {
        const res = await userVipSignInfoSearch({
          cityCode,
          token,
          appCode: 'platform',
          currentGoodsId: goodsGuid,
        });
        if (res.data) {
          this.price = res.data.price;
          this.isRetentionWindowAB = res.data.isRetentionWindowAB;
          this.cancelSignDelay = res.data.cancelSignDelay;
          this.nextRenewalAmount = res.data.nextRenewalAmount;
          this.amountSaved = res.data.amountSaved || 0;
          this.nextRenewalDate = res.data.nextRenewalDate;
          this.propVersion = res.data.propVersion;
          this.signChannel = res.data.signChannel;
          this.tableList[0].value = this.propVersionMap[this.propVersion];
          this.tableList[1].value = this.signChannelMap[this.signChannel];
          this.tableList[2].value = dayjs(this.nextRenewalDate).format('YYYY-MM-DD');
          this.tableList[3].value = `¥${typeof (this.nextRenewalAmount) === 'number' ? this.nextRenewalAmount : ''}`;
        }
        // eslint-disable-next-line no-empty
      } catch {

      }
    },
    closeRenew() {
      UBT.clickButton({
        pageId: 'platform_guanlixufei_page',
        buttonName: 'platform_guanbiziodngxufei',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (this.isRetentionWindowAB) {
        this.showDialogNew = true;
      } else {
        this.showDialog = true;
      }
      UBT.moduleExpose({
        pageId: 'platform_guanlixufei_page',
        categoryId: 'platform',
        moduleId: 'platform_zhijieguanbi',
        contentId: 'platform_zhijieguanbi',
        exposureTimes: 1,
        businessInfo: {},
      });
      UBT.moduleExpose({
        pageId: 'platform_guanlixufei_page',
        categoryId: 'platform',
        moduleId: 'platform_jixuxiangyong',
        contentId: 'platform_jixuxiangyong',
        exposureTimes: 1,
        businessInfo: {},
      });
    },
  },
};
</script>
<style lang="less" scoped>
.renewal-container {
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;

  .renewal-block {
    position: fixed;
    padding-top: 0.24rem;
    bottom: 0;
    z-index: 222;
    height: 5.02rem;
    width: 100%;
    background: linear-gradient(360deg, #fffdf7 2.53%, #fff5e2 73.02%, #ffe5b5 99.09%);
    background-size: cover;
    border-radius: 0.12rem 0.12rem 0 0;

    .renewal-block-title {
      font-family: PingFang SC, sans-serif;
      font-size: 0.18rem;
      font-weight: 500;
      line-height: 0.252rem;
      text-align: center;
    }

    .renewal-close {
      position: absolute;
      top: 0.17rem;
      right: 0.173rem;

      img {
        width: 0.16rem;
        height: 0.16rem;
      }
    }

    .renewal-top {
      display: flex;
      justify-content: space-between;

      /* justify-content: flex-end; */
      padding: 0 0.18rem 0 0.16rem;
      margin-top: 0.15rem;

      .auto-left {
        display: flex;

        .auto-img {
          img.icon {
            width: 0.33rem;
            height: 0.33rem;
          }
        }

        .auto-word {
          margin-left: 0.11rem;

          .auto-top-word {
            font-family: PingFangSC, PingFang SC, sans-serif;
            font-weight: 500;
            font-size: 0.14rem;
            color: #242729;
            line-height: 0.196rem;
          }

          .auto-bottom-word {
            font-family: PingFangSC, PingFang SC, sans-serif;
            font-weight: 400;
            font-size: 0.11rem;
            color: #5a6066;
            line-height: 0.154rem;
            margin-top: 0.03rem;
          }
        }
      }

      .auto-right {
        margin-top: 0.04rem;
        width: 0.86rem;
        height: 0.25rem;
        background: #fff;
        box-shadow: 0 0.01rem 0.02rem 0 #ffe9a9;
        border-radius: 0.06rem;
        text-align: center;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 0.12rem;
        color: #3d2313;
        line-height: 0.25rem;
      }
    }

    .renewal-table {
      margin-top: 0.16rem;
      background: #fff;
      height: 3.87rem;
      border-radius: 0.16rem 0.16rem 0 0;

      .auto-item {
        height: 0.52rem;
        display: flex;
        justify-content: space-between;
        line-height: 0.52rem;
        margin: 0 0.28rem;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 400;
        font-size: 0.14rem;
        border-bottom: 0.005rem solid rgba(0, 0, 0, 0.06);

        .auto-item-left {
          color: #242729;
          font-weight: 500;
        }

        .auto-item-right {
          color: #5a6066;
        }

        .auto-item-right-flex {
          display: flex;
          flex-direction: column;
          line-height: 1.3;
          justify-content: center;
          align-items: flex-end;
          color: rgba(90, 96, 102, 1);

          .auto-item-bottom {
            font-size: 0.12rem;
          }
        }
      }

      .last-item {
        height: 0.52rem;
        display: flex;
        justify-content: space-between;
        line-height: 0.52rem;
        margin: 0 0.28rem;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 400;
        font-size: 0.14rem;
        border-bottom: 0 solid rgba(0, 0, 0, 0.06);

        .auto-item-left {
          color: #242729;
          font-weight: 500;
        }

        .auto-item-right {
          color: #5a6066;
        }
      }
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 220;
  }
}
</style>
